import Online from "./online";

const options = {
  url: "/favicon.ico",
  delay: 10,
  downTriggerCount: 3,
  upTriggerCount: 2,
};

let onlineChecker = null;
let onlineStatusChangedCallback = null;
let downCount = 0;
let upCount = 0;
let checkInterval = null;
let isOffline = false;

const checkCallback = (status) => {
  if (!status) {
    console.log("Offline");
    ++downCount;
    if (
      downCount >= options.downTriggerCount &&
      onlineStatusChangedCallback &&
      !isOffline
    ) {
      isOffline = true;
      onlineStatusChangedCallback(false);
    }
  } else {
    downCount = 0;
    if (isOffline) {
      ++upCount;
      if (upCount >= options.upTriggerCount) {
        isOffline = false;
        onlineStatusChangedCallback(true);
      }
    }
  }
};

const onCheck = () => {
  if (onlineChecker) {
    onlineChecker.checkStatus(checkCallback);
  }
};

const startOnlineCheck = (statusCallback) => {
  clearInterval(checkInterval);
  onlineChecker = Online(options);
  onlineStatusChangedCallback = statusCallback;
  checkInterval = setInterval(onCheck, options.delay * 1000);
};

const stopOnlineCheck = () => {
  if (onlineChecker && checkInterval) {
    clearInterval(checkInterval);
    onlineChecker = null;
  }
};

export default {
  startOnlineCheck,
  stopOnlineCheck,
};
